/* 🤖 this file was generated by svg-to-ts */
export const mgcIconStopFilled: {
  name: 'stop-filled';
  data: string;
} = {
  name: 'stop-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.58 4.047c-.733.14-1.4.821-1.537 1.57-.06.333-.06 12.433 0 12.766.141.768.806 1.433 1.574 1.574.333.06 12.433.06 12.766 0 .768-.141 1.433-.806 1.574-1.574.06-.333.06-12.433 0-12.766-.141-.768-.806-1.433-1.574-1.574-.306-.056-12.508-.052-12.803.004"/></svg>`
};
